import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { allStyles } from '../styleHelper2';
import styleFilter from '../styleFilter';

const StyledButton = styled(styleFilter(styled.button``))`
  background: 0;
  border: 0;
  padding: 0;
  cursor: pointer;
  appearance: none;
  user-select: none;
  outline: none;
  ${allStyles()}
`;

const EmptyButton = forwardRef(({ type, children, ...props }, ref) => (
  <StyledButton type={type} ref={ref} {...props}>
    {children}
  </StyledButton>
));

EmptyButton.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
};

EmptyButton.defaultProps = {
  type: 'button',
  children: null,
};

export default EmptyButton;
